// --------------------------------------------------------------------------
// tooltip.js
// --------------------------------------------------------------------------
// Toggles a tooltip
// --------------------------------------------------------------------------

RN.tooltip = function() {

  'use strict';

  function init() {
    byBehaviour('tooltip').on('click', toggleTooltip);
  }

  function toggleTooltip() {
    $(this).closest('.tooltip').toggleClass('tooltip--is-active');
    return false;
  }

  return {
    init: init
  };

}();